import { api } from 'app/config/apiConfig';
import { PaymentMethod } from 'entities/Payment';

interface PaymentArgs {
  invoiceId: string;
  paymentMethod: PaymentMethod;
  isAutopayment: boolean;
  useUserBalance: boolean;
}

interface PaymentResponse {
  redirectionUrl?: 'string';
  paymentData?: CustomAny;
}

export const payInvoiceApi = api.injectEndpoints({
  endpoints: (build) => ({
    payInvoice: build.mutation<PaymentResponse, PaymentArgs>({
      query: ({ invoiceId, paymentMethod, isAutopayment, useUserBalance }) => ({
        url: `/billing-documents/invoices/${invoiceId}/pay`,
        method: 'POST',
        params: { paymentMethod, isAutopayment, useUserBalance },
      }),
      invalidatesTags: ['Invoices', 'Deposit Payment', 'Contract details', 'Deposit History'],
    }),
  }),
});

export const { usePayInvoiceMutation } = payInvoiceApi;
